import App from 'App';
import { createBrowserRouter } from 'react-router-dom';
import ProtectedRoute from 'routes/protectedRoutes/ProtectedRoute';
import TargetList from 'views/admin/dashboard/components/targetList/TargetList';
import Dashboard from 'views/admin/dashboard/Dashboard';
import ExportPage from 'views/admin/export/ExportPage';
import OverviewPage from 'views/admin/overview/OverviewPage';
import Roles from 'views/admin/roles/Roles';
import SourcesPage from 'views/admin/sources/Sources';
import DocumentPageActions from 'views/admin/documents/DocumentPageActions';
import DocumentPageIndicators from 'views/admin/documents/DocumentPageIndicators';
import DocumentPageSubTargets from 'views/admin/documents/DocumentPageSubTargets';
import DocumentPageTargets from 'views/admin/documents/DocumentPageTargets';
import DocumentPage from 'views/admin/documents/DocumentsPage';
import Homepage from 'views/public/homepage/Homepage';
import LoginPage from 'views/public/loginPage/LoginPage';
import TargetDashoboard from 'views/admin/target/TargetDashboard';
import Target from 'views/admin/target/components/Target';
import Charts from 'views/admin/target/components/charts/Charts';
import Indicator from 'views/admin/target/components/Indicator';
import ArchivePage from 'views/admin/archive/ArchivePage';

export const router = createBrowserRouter([
	{
		path: '/',
		element: <App />,
		children: [
			{
				path: '/',
				element: <Homepage />,
				index: true,
			},
			{
				path: '/login',
				element: <LoginPage />,
			},
			{
				path: '/dashboard',
				element: <ProtectedRoute><Dashboard /></ProtectedRoute>,
				handle: {
					crumb: () => 'Dashboard',
				},
			},
			{
				path: '/targets',
				element: <ProtectedRoute><TargetList /></ProtectedRoute>,
				handle: {
					crumb: () => 'Obiettivi',
				},
			},
			{
				path: '/targets/:targetIndex',
				element: <ProtectedRoute><TargetDashoboard /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Obiettivo ${data.targetIndex}`,
				},
			},
			{
				path: '/targets/:targetIndex/view',
				element: <ProtectedRoute><Target /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Obiettivo ${data.targetIndex}`,
				},
			},
			{
				path: '/targets/:targetIndex/subtargets/:subtargetIndex/actions/:actionIndex/indicators/:indicatorIndex/:timePeriod/view',
				element: <ProtectedRoute><Indicator /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Obiettivo ${data.targetIndex}`,
				},
			},
			{
				path: '/targets/:targetIndex/edit',
				element: <ProtectedRoute><Target isReadOnly={false} /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Obiettivo ${data.targetIndex}`,
				},
			},
			{
				path: '/targets/:targetIndex/subtargets/:subtargetIndex/actions/:actionIndex/indicators/:indicatorIndex/:timePeriod/edit',
				element: <ProtectedRoute><Indicator isReadOnly={false} /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Obiettivo ${data.targetIndex}`,
				},
			},
			{
				path: '/targets/:targetIndex/charts',
				element: <ProtectedRoute><Charts /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Obiettivo ${data.targetIndex}`,
				},
			},
			{
				path: '/roles',
				element: <ProtectedRoute><Roles isUserAdmin={true} isUserAdminRolesEditor={true} /></ProtectedRoute>,
				handle: {
					crumb: () => 'Ruoli',
				},
			},
			{
				path: '/documents',
				element: <ProtectedRoute><DocumentPage isUserAdmin={false} isUserAdminRolesEditor={false} /></ProtectedRoute>,
				handle: {
					crumb: () => 'Documents',
				},
			},
			{
				path: '/overview',
				element: <ProtectedRoute><OverviewPage /></ProtectedRoute>,
				handle: {
					crumb: () => 'Panoramica documento',
				},
			},
			{
				path: '/export',
				element: <ProtectedRoute><ExportPage /></ProtectedRoute>,
				handle: {
					crumb: () => 'Esporta dati documento',
				},
			},
			{
				path: '/sources',
				element: <ProtectedRoute><SourcesPage isUserAdmin={true} /></ProtectedRoute>,
				handle: {
					crumb: () => 'Fonti',
				},
			},
			{
				path: '/documents/:templateCode/targets',
				element: <ProtectedRoute><DocumentPageTargets isUserAdmin={false} isUserAdminRolesEditor={false} /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Document ${data.templateCode}`,
				},
			},
			{
				path: '/documents/:templateCode/targets/:targetIndex/subtargets',
				element: <ProtectedRoute><DocumentPageSubTargets isUserAdmin={false} isUserAdminRolesEditor={false} /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Obiettivo ${data.targetIndex}`,
				},
			},
			{
				path: '/documents/:templateCode/targets/:targetIndex/subtargets/:subtargetIndex/actions',
				element: <ProtectedRoute><DocumentPageActions isUserAdmin={false} isUserAdminRolesEditor={false} /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Sotto-obiettivo ${data.subtargetIndex}`,
				},
			},
			{
				path: '/documents/:templateCode/targets/:targetIndex/subtargets/:subtargetIndex/actions/:actionIndex/indicators',
				element: <ProtectedRoute><DocumentPageIndicators isUserAdmin={false} isUserAdminRolesEditor={false} /></ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Azione ${data.actionIndex}`,
				},
			},
			{
				path: '/archive',
				element: 
				<ProtectedRoute>
					
					<ArchivePage />
				
				</ProtectedRoute>,
				handle: {
					crumb: (data: any) => `Archivio`,
				},
			}
		]
	}

]);